import styled from 'styled-components';
import spacing from '../../../helpers/spacing';

export const SpinnerContainer = styled.div`
  position: absolute;
  right: ${spacing(2)};
  top: ${spacing(1.5)};
`;
